module.exports = __webpack_public_path__ + "img/dataservice_gzy.61b04c5e.png";